module.exports = __webpack_public_path__ + "static/tech-8d1906258ec53bebefe5f2f30fdcd31b.png";